import React from 'react';
import { number, func } from 'prop-types';
import ReactPaginate from 'components/pagination';

export default class ItemPagination extends React.Component {
    constructor(props) {
        super(props);
        this.clickPage = this.clickPage.bind(this);
        this.handleResize = this.resize.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }


    resize = () => this.forceUpdate();

    clickPage(value) {
        this.props.changePage(value.selected);
    }

    showingFrom = () => (this.props.currentPage * this.props.perPage) + 1;

    showingTo() {
        let result = (this.showingFrom() + this.props.perPage) - 1;
        if (result > this.props.totalItems) {
            result = this.props.totalItems;
        }
        return result;
    }

    render() {
        if (this.props.totalItems < 1) {
            return null;
        }
        const pageRangeDisplayed = window.innerWidth >= 768 ? 5 : 1;

        return (
            <div className="pagination-wrapper">
                <div className="pagination-status">
                    Showing&nbsp;
                    <span>{this.showingFrom()}</span> - <span>{this.showingTo()}</span>&nbsp;
                    of&nbsp;
                    <span>{this.props.totalItems}</span>
                </div>
                {this.props.totalPages > 1 && (
                    <ReactPaginate
                        pageNum={this.props.totalPages}
                        pageRangeDisplayed={pageRangeDisplayed}
                        marginPagesDisplayed={1}
                        clickCallback={this.clickPage}
                        forceSelected={this.props.currentPage}
                        initialSelected={this.props.currentPage}
                        previousLabel="Previous"
                        prevIcon="chevron-left"
                        nextLabel="Next"
                        nextIcon="chevron-right"
                        containerClassName="c-pagination-simple"
                        pageClassName="page btn-skin-3"
                        mobileBreakpoint={768}
                    />
                )}
            </div>
        );
    }
}

ItemPagination.propTypes = {
    totalPages: number.isRequired,
    currentPage: number.isRequired,
    perPage: number.isRequired,
    totalItems: number.isRequired,
    changePage: func.isRequired
};
